import React from 'react'
import CommonHeader from './common/CommonHeader'
import '../torfacts.css'
import Footer from './common/Footer'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KnowMore from './common/KnowMore';


const PrivacyPolicy = () => {
  return (
    <>
    <div className="main-content">
        <CommonHeader title={'Privacy Policy'} stitle={'Your privacy is important to us'} id={"2"} />
        
    </div>
    <div className='pageContent bg-light-blue'>
      <div className="main-content">
        <p className='small'><b>Last updated on 23rd.February.2021</b></p>
        <p className='page-content'>Torfac (together with its affiliates, the "Company") owns and operates a number of different websites, mobile 
apps, and interactive services, including without limitation Wisesample.com, Flapbucks.com, Torfacts.com, and 
others (collectively, the "Torfac Sites"). This privacy policy ("Privacy Policy") applies to the Torfac Sites and to all 
of the features, mobile applications, emails, online services and other functionalities, whether accessed via a 
computer, mobile device, or otherwise and the services available on or through the Torfac Sites and Features 
(the "Services"). This Privacy Policy only covers information collected by the Company through the Torfac Sites 
and Features and our Services, and does not cover any information received or collected offline by the 
Company (unless specifically stated) or collected by any unrelated websites or companies to which we may 
provide links.</p>
        <p className='page-content'>It is expected that the panellist/respondent shall fill out his profile honestly and truthfully and not submit 
wrong or incorrect information simply to qualify for more surveys. It is also expected that panellist/respondent 
shall not manipulate his answers or use other unfair means (changing IP, multiple accounts etc) during survey 
filling to earn incentives. Torfacts has sufficient safeguards to detect such anomalies and if such behaviour is 
noticed, the panellist will be banned/blocked from Torfacts and all/any of his redemption requests shall be 
cancelled.</p>
        <p className='page-content'>Torfac is strongly committed to safeguarding your privacy with us. The following privacy policy explains how 
your personal information is held and treated as you explore our website and services.</p>
        <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          What personally identifiable information does Torfacts.com collect from me?
        </AccordionSummary>
        <AccordionDetails>
           Torfacts.com collects information in several manners from different parts of our website and network. Some information is gathered when you sign up. During member registration, Torfacts.com asks for your name, email address, zip code and household information. The more information you volunteer to provide accurately, the better we are able to offer you services and rewards. Additionally, if you ever contact Torfacts.com through any means, we may keep a record of that correspondence. Whenever Torfacts.com collects any such information, we aim to include a link to this Privacy Policy on that page.
        </AccordionDetails>
      </Accordion>
      <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          What are cookies and how does Torfacts.com use them?
        </AccordionSummary>
        <AccordionDetails>
          A cookie is a packet of electronic data sent to your browser, from a web server and stored on your computer's hard drive. As part of offering you specific surveys, information, and personalized services, Torfacts.com may use cookies to store and sometimes track information about you. Torfacts.com may require that you accept cookies for preparing such specific content for you. This also avoids you having to enter your login information every time.
        </AccordionDetails>
      </Accordion>

      <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          What is Torfacts.com policy on allowing me to update, edit, change or delete my personal account information?
        </AccordionSummary>
        <AccordionDetails>
          You may edit your Torfacts.com Account Information any time by using your Torfacts.com Log in and password. Please contact support@Torfacts.com for further instructions about deactivating your Torfacts.com account.
        </AccordionDetails>
      </Accordion>

      <Accordion className='torfacts-accordion'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4-content"
          id="panel4-header"
        >
           Who is collecting information and for what purpose?
        </AccordionSummary>
        <AccordionDetails>
      Torfacts.com collects several information through surveys and registration and other means, which helps its research clients develop new products and services for consumers. You are sharing that information with Torfacts.com only, unless it is specifically stated otherwise on any survey you participate. If data is being collected and/or maintained by any company other than Torfac -- or Torfac sites, you will be notified prior to the time of the data collection or transfer. If you do not want your data to be shared, you may choose not to allow the transfer by not using that particular survey or product.<br/><br/>

Rewards and promotions that we offer on Torfacts.com may be either sponsored by other companies independently, or may be co-sponsored by Torfacts.com and another company. Some data collected during such a promotion may be shared with the sponsor. However, you will be notified prior to the time of data collection or transfer. You can decide not to participate in that particular promotion if you do not want to share your data.<br/><br/>

Any specific Sensitive Information (like information specifying medical or health conditions, racial or ethnic origin, political views, religious or spiritual beliefs, trades and union membership or information specifying the sex life of the individual) will be treated with additional care. If Torfacts.com intends to share such information to another company for a different purpose than originally collected, then you will be expressly asked permission prior to any such disclosure.
        </AccordionDetails>
      </Accordion>
     
      </div>
    </div>
    <KnowMore />
    <Footer />
    </>
  )
}

export default PrivacyPolicy